import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import OptionsComponent from "./OptionsComponent";
// CSS STYLES
import styles from "../../styles/Components/Shared/ListPageTable.module.css";
// ICONS    
const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';
const EditIcon = '/static/img/SvgIcons/icons-edit-pen-blue.svg';


const ListPageHeaders = ({tableKeyObjects, getGridTemplate, endColumn}) => {
    const headerCount = tableKeyObjects.filter(header => header.label)

    if (headerCount.length === 0) {
        return null
    }

    return (
        <div className={styles.sub_table_header_container} style={{gridTemplateColumns: `${getGridTemplate(tableKeyObjects)}`}}>
            {tableKeyObjects.map((header,i) => 
                {
                    return ( 
                        <div key={`${header.label}-${i}`} className={styles.single_header_container} style={header.label === 'Edit' || header.label === 'More' ? {alignItems: 'end'} : {}}>
                            <p>{header.label}</p>
                        </div>
                    ) 
                }
            )}

            {endColumn ? 
                endColumn
            : null}
        </div>
    )
}

const ListPageSubTable = ({
    tableKeyObjects,
    tableData,
    menuRef,
    index,
    openMenuIndex, setOpenMenuIndex
}) => {
    const getGridTemplate = (dataKeyObjects) => {
        let gridFrs = dataKeyObjects.map((obj) => obj.width ? `minmax(${obj.width}, ${obj.gridFr}fr)` : ` ${obj.gridFr}fr`).join(' ')
        return gridFrs;
    }


    return (
        <div className={styles.eventDash_sub_table_main_container}>
            
            <div className={`${styles.sub_table_container}`}>
                
                {/* Table Header */}
                <ListPageHeaders tableKeyObjects={tableKeyObjects} getGridTemplate={getGridTemplate} />

                {/* Data Rows */}
                {tableData.length > 0 ? (
                
                    
                    tableData.map((data, i) => (
                        <div className={styles.sub_table_row} style={{gridTemplateColumns: `${getGridTemplate(tableKeyObjects)}`}} key={`table-row-${i}`}>
                            {

                                tableKeyObjects.map((dataKeyObj, idx) => {

                                        return (
                                            // GENERIC
                                            dataKeyObj.dataKey === 'generic' ? 
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    onClick={() => dataKeyObj.callback ? dataKeyObj.callback(data): {}}
                                                    style={dataKeyObj.addedStyle ? dataKeyObj.addedStyle : {}}

                                                >
                                                    <div className={`${styles.regular_data}`} >
                                                        {dataKeyObj.getName ? dataKeyObj.getName(data) : data[dataKeyObj.property] }
                                                        {dataKeyObj.checkSpecial ? 
                                                            dataKeyObj.checkSpecial(data, i)
                                                        : null}
                                                    </div>
                                            </div>
                                            : dataKeyObj.label === 'Edit' || dataKeyObj.isEditOptions ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.edit_cell_container} >
                                                    {dataKeyObj.editCallback ?
                                                        <div className={styles.edit_icon_container} onClick={() => dataKeyObj.editCallback ? dataKeyObj.editCallback(data) : {}}>
                                                            <img src={EditIcon} alt="Trash Icon" />
                                                        </div>
                                                    : null}
                                                    {dataKeyObj.deleteCallback ?
                                                        <div className={styles.edit_icon_container} onClick={() => dataKeyObj.deleteCallback ? dataKeyObj.deleteCallback(data) : {}}>
                                                            <img src={TrashIcon} alt="Trash Icon" />
                                                        </div>
                                                    : null}
                                                </div>
                                            ) : dataKeyObj.advancedEditOptions ? (
                                                <OptionsComponent key={`table-cell-${i}-${idx}`} openMenuIndex={openMenuIndex} setOpenMenuIndex={setOpenMenuIndex} menuRef={menuRef} menuIndex={`${index}-${i}`} data={data} advancedEditOptions={dataKeyObj.advancedEditOptions} addedStyle={{ paddingRight: '15px' }}/>

                                            ) : (
                                                <div></div>
                                            )
                                        )
                                        
                                })
                            }
                        </div>
                    ))
                ) : null}

            </div>
          
        </div>
    ) 

};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
})(ListPageSubTable);



